import React from "react";
import { ChevronRight } from "lucide-react";
import { LINKS } from "../mock/data";

export default function PageHero({ image, kicker, title, subtitle, shopLink = LINKS.shop }) {
  return (
    <section className="relative h-[70vh] min-h-[520px] w-full overflow-hidden">
      <img src={image} alt={title} className="absolute inset-0 w-full h-full object-cover animate-kenburns" />
      <div className="absolute inset-0 bg-gradient-to-t from-[#0a0a0a] via-black/50 to-black/40" />
      <div className="absolute inset-0 bg-gradient-to-r from-black/70 to-transparent" />
      <div className="relative z-10 h-full max-w-[1400px] mx-auto px-5 md:px-8 flex flex-col justify-center">
        <div className="flex items-center gap-3 mb-5">
          <span className="h-[2px] w-10 bg-baja-red" />
          <span className="font-cond uppercase tracking-[0.25em] text-sm text-white/80">{kicker}</span>
        </div>
        <h1 className="font-display text-5xl sm:text-6xl md:text-8xl uppercase leading-[0.9] text-white max-w-4xl">
          {title}
        </h1>
        <p className="mt-6 text-lg md:text-xl text-white/75 max-w-xl leading-relaxed">{subtitle}</p>
        <div className="mt-8">
          <a
            href={shopLink}
            target="_blank"
            rel="noopener noreferrer"
            className="group bg-baja-red hover:bg-[#ff1a44] transition-colors text-white font-cond font-600 uppercase tracking-wider px-8 py-4 inline-flex items-center gap-2 text-lg"
          >
            Shop The Range
            <ChevronRight size={20} className="group-hover:translate-x-1 transition-transform" />
          </a>
        </div>
      </div>
    </section>
  );
}
